import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import {
  addOnDefSchema,
  discountDefSchema,
  profitItemDefSchema,
} from './entities';

export const types = {
  FETCH_ADD_ON_DEFS_ERROR: 'quotes/details/FETCH_ADD_ON_DEFS_ERROR',
  FETCH_ADD_ON_DEFS_SUCCESS: 'quotes/details/FETCH_ADD_ON_DEFS_SUCCESS',
  FETCH_PROFIT_ITEM_DEFS_ERROR: 'quotes/details/FETCH_PROFIT_ITEM_DEFS_ERROR',
  FETCH_PROFIT_ITEM_DEFS_SUCCESS:
    'quotes/details/FETCH_PROFIT_ITEM_DEFS_SUCCESS',
  FETCH_DISCOUNT_DEFS_ERROR: 'quotes/details/FETCH_DISCOUNT_DEFS_ERROR',
  FETCH_DISCOUNT_DEFS_SUCCESS: 'quotes/details/FETCH_DISCOUNT_DEFS_SUCCESS',
  FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS:
    'settings/digitalQuote/FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS',
};

export const fetchAddOns = {
  error: notify(
    (error) => ({
      type: types.FETCH_ADD_ON_DEFS_ERROR,
      payload: error,
    }),
    'Failed to fetch Add-Ons',
  ),
  success: ({ addOns }) => ({
    type: types.FETCH_ADD_ON_DEFS_SUCCESS,
    payload: normalize(addOns, [addOnDefSchema]),
  }),
};

export const fetchProfitItems = {
  error: notify(
    (error) => ({
      type: types.FETCH_PROFIT_ITEM_DEFS_ERROR,
      payload: error,
    }),
    'Failed to fetch Pricing Items',
  ),
  success: ({ profitItems }) => ({
    type: types.FETCH_PROFIT_ITEM_DEFS_SUCCESS,
    payload: normalize(profitItems, [profitItemDefSchema]),
  }),
};

export const fetchDiscounts = {
  error: notify(
    (error) => ({
      type: types.FETCH_DISCOUNT_DEFS_ERROR,
      payload: error,
    }),
    'Failed to fetch Discounts',
  ),
  success: ({ discounts }) => ({
    type: types.FETCH_DISCOUNT_DEFS_SUCCESS,
    payload: normalize(discounts, [discountDefSchema]),
  }),
};

export const fetchGlobalExpediteOptions = {
  success: ({ globalExpediteOptions }) => ({
    type: types.FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS,
    payload: { globalExpediteOptions },
  }),
};
